import { useMutation } from '@tanstack/react-query';

import CruiseToolsService, { type ExportOffersToSearchBody } from '~/services/cruises/CruiseToolsService';

export function useExportOffersToSearch() {
  return useMutation({
    mutationFn: (body: ExportOffersToSearchBody) => CruiseToolsService.exportOffersToSearch(body),
  });
}
